import axios from 'axios';
import promise from 'promise';
import { REFRESH_TOKEN } from 'fixtures/api';
import { ROUTE_ERR_MAINTENANCE, ROUTE_ERR_OFFLINE } from 'fixtures/routes';
import { removeCredentialsLocal } from 'utils/localData/credentials'

// create custom axios instance
const httpInstance = axios.create();

// implement auth interceptor
httpInstance.interceptors.request.use((config) => {
  const userData = JSON.parse(localStorage.getItem('@Credential'))
  config.headers.authorization = `Bearer ${userData.token}`;
  config.headers.common['Content-Type'] = 'application/json; charset=utf-8';
  config.headers.common['Accept'] = 'application/json';

  return config
}, error => {
  return promise.reject(error)
})

// implement refresh interceptor
httpInstance.interceptors.response.use(res => {
  return res
}, error => {
  const errorResponse = error.response
  if (error.toString() === 'Error: Network Error') {
    window.location.href = `${window.location.protocol}//${window.location.host}/${ROUTE_ERR_OFFLINE}`
  }
  if (errorResponse.status === 401) {
    return resetTokenAndReattemptRequest(error)
  }
  if (errorResponse.status === 502) {
    window.location.href = `${window.location.protocol}//${window.location.host}/${ROUTE_ERR_MAINTENANCE}`
  }
  return Promise.reject(error)
})

// token checker
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

const addSubscriber = (callback) => {
  subscribers.push(callback);
}

const onAccessTokenFetched = (newToken) => {
  subscribers.forEach(callback => callback(newToken));
  subscribers = [];
}

const resetTokenAndReattemptRequest = async error => {
  try {
    const { response: errorResponse } = error;
    const raw = localStorage.getItem('@Credential');
    const userData = JSON.parse(raw);
    const resetToken = userData.refreshToken;
    if (!resetToken) {
      return Promise.reject(error);
    }

    const retryOriginalRequest = new Promise(resolve => {
      addSubscriber(token => {
        errorResponse.config.headers.authorization = 'Bearer ' + token;
        resolve(axios(errorResponse.config));
      });
    });

    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;
      const response = await axios({
        method: 'get',
        url: `${REFRESH_TOKEN}${resetToken}`
      });
      if (!response.data) {
        return Promise.reject(error);
      } else if (response.data) {
        const newToken = response.data.token
        const newUserData = Object.assign(userData)
        newUserData.token = newToken
        localStorage.setItem('@Credential', JSON.stringify(newUserData))
        isAlreadyFetchingAccessToken = false;
        onAccessTokenFetched(newToken);
      }
    }

    return retryOriginalRequest;
  } catch (err) {
    if (err.response.status === 403) {
      removeCredentialsLocal()
      window.location.reload()
    } else {
      if (err.code === 'ECONNABORTED') { }
    }
    return Promise.reject(err);
  }
}

export default httpInstance